import * as React from 'react';
import {connect, Provider} from 'react-redux';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import nvdbapi from '../../../../integration/nvdbapi/nvdbapi';
import server from '../../../../integration/server/server-services';
import {SelectContract, selectContract} from '../../../actions/actions';
import FeatureTypes from "../../contract-features-3/components/FeatureTypes";
import FeatureView from '../../contract-features-3/components/ViewFeatureType';
import {default as reducers} from './../../contract-features-3/reducers/reducers';
import {sendLog} from "../../../../log";
import FeaturesState from "../../contract-features-3/domain/FeaturesState";
import security from "../../../../service/security/security-services";
import contractService from "../../../../service/contract/contract-services";

// TODO this seems dirty
export class ServerHolder {

    constructor(public server: server = null,
                public security: security = null,
                public contract: contractService = null,
                public nvdbapi: nvdbapi = null) {
    }

}

const serverHolder = new ServerHolder();
const store = createStore(reducers, applyMiddleware(thunk.withExtraArgument(serverHolder)));

interface Contract3dViewProps {
    selectContract: SelectContract;
    contractId: string;
    isInitializing: boolean;
    isFetching: boolean,
    showingFullscreen: boolean,
    splitScreenDirection: string
}

class Contract3dView extends React.Component<Contract3dViewProps, {}> {

    componentDidMount() {
        const {contractId, isInitializing} = this.props;
        if (isInitializing) {
            this.props.selectContract(contractId);
        }
        sendLog({message: "Loaded 3D view", loggerName: "view.contract-3d"});
    }

    render() {
        return <div>
            {this.props.isFetching && <div className="datafangst-loading"/>}
            {!this.props.showingFullscreen && <FeatureTypes/>}
            <FeatureView activeTab={'3d'}/>
        </div>;
    }

}

interface Contract3dProps {
    $routeParams: angular.route.IRouteParamsService,
    server: server,
    security: any,
    contract: any,
    nvdbapi: nvdbapi
}

export class Contract3d extends React.Component<Contract3dProps, {}> {

    render() {
        const mapStateToProps = (state: FeaturesState) => {
            const contractid = this.props.$routeParams["contractId"];
            return {
                contractId: contractid,
                isInitializing: !state.isFetching && (!!state.contractId || state.contractId != contractid),
                isFetching: !!state.user && state.isFetching,
                showingFullscreen: state.showingFullscreen,
                splitScreenDirection: state.splitScreenDirection
            }
        };

        const mapDispachToProps = ({
            selectContract
        });

        const {server, security, contract, nvdbapi} = this.props;
        serverHolder.server = server;
        serverHolder.security = security;
        serverHolder.contract = contract;
        serverHolder.nvdbapi = nvdbapi;
        const App = connect(mapStateToProps, mapDispachToProps)(Contract3dView);
        return <Provider store={store} key="provider">
            <App/>
        </Provider>
    }

}
